export const LOGGED_IN = "loggedIn";
export const AUTH_STATE = "authState";
export const BUSY_LOGGING_IN = "loggingIn";
export const CURRENT_USER = "currentUser";
export const BUSY_LOGGING_IN_WITH_EMAIL_AND_PASSWORD = "busyLoggingInWithEmailAndPassword";
export const BUSY_LOGGING_IN_WITH_GOOGLE = "busyLoggingInWithGoogle";
export const BUSY_LOGGING_IN_WITH_APPLE = "busyLoggingInWithApple";
